import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'
import web from './web'
import auth from './auth'
import dashboard from './dashboard'

Vue.use(Router)

const routes = [
  ...web,
  ...auth,
  ...dashboard
]

const router = new Router({
  mode: 'history',
  routes
})

router.beforeEach((to, from, next) => {
  store.dispatch('App/setInitialState').then(() => {
    const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
    const requiresGuest = to.matched.some(record => record.meta.requiresGuest)
    const { permission, ensureCanSeeFunctionalities } = to.matched[to.matched.length - 1].meta
    const isAuthenticated = store.getters['Auth/isAuthenticated']
    const userPermissions = store.getters['Auth/getPermissions']
    const canSeeFunctionalities = store.getters['Auth/canSeeFunctionalities']

    if (permission && process.env.APP_SUPER == 'false' && userPermissions && userPermissions[permission.name][permission.action] === false) {
      next({
        name: 'Home'
      })
    } else if (ensureCanSeeFunctionalities && !canSeeFunctionalities) {
      next({
        name: 'Home'
      })
    } else if (requiresGuest && isAuthenticated) {
      next({
        name: 'Home'
      })
    } else if (requiresAuth && !isAuthenticated) {
      next({
        name: 'Login',
        query: {
          redirect: to.fullPath
        }
      })
    } else {
      next()
    }

    document.title = `${process.env.APP_NAME} - ${to.meta.title}`
  })
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js